const palette = {
  brown: {
    main: "#442E0B",
  },
  gold: {
    lighter: "#FEF9EC",
    light: "#FDF3D9",
    main: "#F5C340",
    dark: "#E5B026",
  },
  ink: {
    lighter: "#666666",
  },
  primary: {
    main: "#0D4464",
    states: {
      hover: "#F8FAFC",
      hoverLight: "#1976D214",
    },
  },
  secondary: {
    main: "#FFFFFF",
  },
};

export default palette;
